import { t } from "i18next";

export const useKeyByWord = (typeKey, key) => {
    const words = {
        'resource_type': {
            'E': t('EMP'),
            'V': t('VEH'),
            'C': t('CONT'),
        },
        'aptitude_status': {
            "0": t('APT'),
            "1": t('PART_APT'),
            "2": t('UN_APT'),
            "99": 'NC'
        },
        'resource_detail': {
            "EMP": t('EMP_DETAIL'),
            "VEH": t('VEH_DETAIL'),
            "VIS": t('VIS_DETAIL'),
            "VEHVIS": t('VEH_DETAIL'),
        },
    }
    if (words[typeKey][key]) {
        return words[typeKey][key];
    } else {
        return '-'
    }
}